<script>
import { defineComponent } from "vue";
import VideoElement from "@/components/graphics/VideoElement.vue";
import ProductHelperMixin from "@/mixins/productHelperMixin";
import Graphic from "@/components/graphics/Graphic.vue";

export default defineComponent({
  name: "AnimatedRegion",
  components: { Graphic, VideoElement },
  mixins: [ProductHelperMixin],
  props: {
    product: {
      type: Object,
      default: () => {
        return {};
      }
    },
    region: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  computed:{
    sources(){
      return [this.extractProductProp('contentSource')];
    },
    autoplay() {
      return this.extractProductProp('inblockAutoplay') || true;
    },
    delay(){
      return Number(this.extractProductProp('inblockDelay') || 0);
    },
    loop() {
      return this.extractProductProp('inblockLoop') || false;
    },
    loopCount() {
      return parseInt(this.extractProductProp('loopCount') || 0, 10);
    }
  }
});
</script>

<template>
  <graphic :src="sources" :muted="true" :loop="loop" :autoplay="autoplay" :delay="delay" :loop-count="loopCount" />
</template>

<style scoped lang="scss">
  video, canvas, img  {
    width: 100%;
    height: 100%;
  }
</style>
